import React, { useEffect, useRef, useState } from 'react';

const PinInput = ({ pin, setPin, onPinComplete }) => {
    const inputRef = useRef(null);
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    const handlePinChange = (e) => {
        const newPin = e.target.value.replace(/[^0-9]/g, '');
        if (newPin.length <= 6) {
            setPin(newPin);
            if (newPin.length === 6 && onPinComplete) {
                onPinComplete(newPin);
            }
        }
    };

    const handleContainerClick = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    // Determines the CSS classes for each individual box
    const getBoxClassName = (index) => {
        let className = 'pin-box-login';
        if (pin.length > index) {
            className += ' filled';
        }
        // Add 'active' class to the current input box when focused
        if (isFocused && index === pin.length) {
            className += ' active';
        }
        return className;
    };

    return (
        <div className="pin-input-container-login" onClick={handleContainerClick}>
            <div className="pin-boxes-login">
                {[...Array(6)].map((_, index) => (
                    <div key={index} className={getBoxClassName(index)}>
                        {pin[index] ? '●' : ''}
                    </div>
                ))}
            </div>
            <input
                ref={inputRef}
                type="tel"
                value={pin}
                onChange={handlePinChange}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                maxLength="6"
                className="hidden-pin-input"
                autoComplete="one-time-code"
            />
        </div>
    );
};

export default PinInput;